import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'
import { Line } from 'vue-chartjs'
import { computed } from 'vue'
import Misc from '../../../utils/helper/misc'
ChartJS.defaults.font.family = 'Helvetica Now Micro W05 Regular'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)
// Made this method to remove Cognitive complexity
function ticksCallback(value, index, ticks, props) {
  if (props.isEarningReport) {
    return Misc.formatPrice(value)
  }
  return value
}
export default {
  components: {
    Line
  },
  props:{
    labels: {
      type: Object,
      default: {}
    },
    datas:{
      type: Object,
      default: {}
    },
    isEarningReport:{
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const chartData = computed(()=>{
      return {
        labels: props.labels,
        datasets: [
          {
            label: 'Earning',
            data: props.datas,
            cubicInterpolationMode: 'monotone',
            borderColor: '#1A73E8',
            pointBackgroundColor: 'white',
            pointRadius: 4,
            fill: true,
            backgroundColor: (ctx) => {
              const canvas = ctx.chart.ctx
              const gradient = canvas.createLinearGradient(0, 0, 0, 380)
              gradient.addColorStop(0, 'rgba(26, 115, 232, 0.4)')
              gradient.addColorStop(1, 'rgba(255, 255, 255, 0)')
              return gradient
            }
          }
        ]
      }
    })
    const chartOptions = computed(()=>{
      return {
        scales: {
          x: {
            grid: {
              drawBorder: false,
              borderColor: 'transparent',
              borderStyle: 'dotted',
              color: (ctx) => (ctx.index === 0 ? '#C3CAD4' : '#CFD5DD80'),
              zeroLineColor: 'rgba(255,255,255,0.5)',
              tickLength: 0,
              lineWidth: 2,
            },
            border: {
              dash: (ctx)=>(ctx.index === 0 ?[]:[5,5]),
              dashOffset: 0,
            },
            ticks: {
              padding: 20,
              maxRotation: 60,
              minRotation: 50
            },
          },
          y: {
            grid: {
              drawBorder: false,
              borderColor: 'transparent',
              borderStyle: 'dotted',
              color: (ctx) => (ctx.index === 0 ? '#C3CAD4' : '#CFD5DD80'),
              tickLength: 0,
              lineWidth: 2,
            },
            border: {
              dash: (ctx)=>(ctx.index === 0 ?[]:[5,5]),
              dashOffset: 0
            },
            ticks: {
              precision: 0,
              padding: 24,
              callback: (value, index, ticks) => ticksCallback(value, index, ticks, props)
            },
            beginAtZero: true
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            yAlign: 'bottom',
            callbacks: {
              label: function (tooltipItem) {
                if (props.isEarningReport) {
                  const formattedPrice = Misc.formatPrice(tooltipItem.raw)
                  if (tooltipItem.raw < 0) {
                    const multiReturnStatement = [`The negative dip of ${formattedPrice}`]
                    multiReturnStatement.push(' in the graph is a reflection of a refund')

                    return multiReturnStatement
                  }
                  return formattedPrice
                }

                return tooltipItem.raw
              }
            }
          }
        },
        animation: false,
      }
    })

    return {
      chartData,
      chartOptions
    }
  }
}
